import React from 'react'

import { Col, Row } from '@yes.technology/react-toolkit'
import NavigationSliderTitle from '../NavigationSliderTitle/NavigationSliderTitle'
import {
  ActionsContainer,
  CollapsibleAreaLine,
  CollapsibleContainer,
  StyledGrid
} from './styles'

type SectionDividerProps = {
  title?: string
  color?: string
  backgroundColor?: string
  children?: React.ReactNode
  centerHeaderElement?: React.ReactElement
  rightHeaderElement?: React.ReactElement
  embedded?: boolean
  disabled?: boolean
  isVisible?: boolean
  isCollapsibleCard?: boolean
  hideCollapsibleCardArrow?: boolean
  navSticky?: boolean
} & React.HTMLAttributes<HTMLDivElement>

const SectionDivider = ({
  title = '',
  children,
  centerHeaderElement,
  rightHeaderElement,
  backgroundColor,
  color,
  embedded,
  isVisible = true,
  isCollapsibleCard = false,
  hideCollapsibleCardArrow = false,
  navSticky,
  ...htmlProps
}: SectionDividerProps) => {
  const leftHeaderElement = (
    <NavigationSliderTitle title={title} color={color} />
  )

  const actions = centerHeaderElement ? (
    <ActionsContainer>{centerHeaderElement}</ActionsContainer>
  ) : undefined

  if (!isVisible)
    return (
      <StyledGrid>
        <Row style={{ justifyContent: 'center' }}>
          <Col lg={12}>{children}</Col>
        </Row>
      </StyledGrid>
    )

  if (isCollapsibleCard) {
    return (
      <CollapsibleAreaLine
        heightClass='small'
        leftHeaderElement={leftHeaderElement}
        centerHeaderElement={actions}
        rightHeaderElement={rightHeaderElement}
        alignSecondPosition='right'
        headerColor='blue'
        defaultOpenState
        backgroundColor={backgroundColor}
        color={color}
        navSticky={navSticky}
        displayToggleButton={!hideCollapsibleCardArrow}
      >
        {children}
      </CollapsibleAreaLine>
    )
  }

  return (
    <CollapsibleContainer
      data-testid='section-divider'
      headerColor='blue'
      heightClass='small'
      leftHeaderElement={leftHeaderElement}
      centerHeaderElement={actions}
      rightHeaderElement={rightHeaderElement}
      alignSecondPosition='center'
      defaultOpenState
      backgroundColor={backgroundColor}
      color={color}
      embedded={embedded}
      navSticky={navSticky}
      displayToggleButton={!hideCollapsibleCardArrow}
      {...htmlProps}
    >
      {children}
    </CollapsibleContainer>
  )
}

export default SectionDivider
